import {ReactComponent as Simple} from 'assets/images/farm/typesAd/simple.svg';
import {ReactComponent as SimpleDisable} from 'assets/images/farm/typesAd/simple-disable.svg';
import {ReactComponent as Auction} from 'assets/images/farm/typesAd/auction.svg';
import {ReactComponent as AuctionDisable} from 'assets/images/farm/typesAd/auction-disable.svg';
import {ReactComponent as Sale} from 'assets/images/farm/typesAd/sale.svg';
import {ReactComponent as SaleDisable} from 'assets/images/farm/typesAd/sale-disable.svg';
import {ReactComponent as Presale} from 'assets/images/farm/typesAd/presale.svg';
import {ReactComponent as PresaleDisable} from 'assets/images/farm/typesAd/presale-disable.svg';

export const enableTypeAdsImage: Record<string, React.ReactElement> = {
  simple: <Simple />,
  auction: <Auction />,
  sale: <Sale />,
  prepayment: <Presale />,
};
export const disableTypeAdsImage: Record<string, React.ReactElement> = {
  simple: <SimpleDisable />,
  auction: <AuctionDisable />,
  sale: <SaleDisable />,
  prepayment: <PresaleDisable />,
};
